import LoginForm from "../../components/auth/forms/LoginForm";

import "./LoginPage.css";

const LoginPage = () => {

  return (
    <LoginForm />
  );
};

export default LoginPage;
